import { NavLink, Outlet, useOutletContext } from "react-router";
import { PageHeader } from "@/components/bespoke";
import { cn } from "@/lib/utils";
import type { ShellOutletContext } from "@/components/app-shell";

const studioTabs = [
  { to: "/studio/workflows", label: "Workflows" },
  { to: "/studio/skills", label: "Skills" },
  { to: "/studio/tools", label: "Tools" },
  { to: "/studio/evals", label: "Evals" },
];

/**
 * The Studio authoring workspace: workflows, skills, tools, and evals for one project.
 * Every tab has its own deep link. The title carries no helper text.
 */
export function StudioPage() {
  const context = useOutletContext<ShellOutletContext | null>();
  return (
    <div className="flex flex-col gap-6">
      <PageHeader title="Studio" />
      <nav aria-label="Studio tabs" className="flex gap-1 overflow-x-auto">
        {studioTabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) =>
              cn(
                "inline-flex h-7.5 items-center justify-center rounded-sm px-3 text-[0.8125rem] font-medium whitespace-nowrap outline-none transition-colors",
                "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring",
                isActive
                  ? "bg-primary font-semibold text-primary-foreground"
                  : "bg-muted text-muted-foreground hover:text-foreground",
              )
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
      <div className="flex min-w-0 flex-1 flex-col gap-6">
        <Outlet context={context} />
      </div>
    </div>
  );
}
